import wrapWithProvider from './src/boot/wrap-with-provider'


export const wrapRootElement = wrapWithProvider
